<template>
  <v-row class="fill-height pa-0 ma-0">
    <v-col cols="12" lg="12"
           class="d-flex justify-start align-start fill-height flex-column mx-auto pa-lg-10">
      <v-sheet class="mb-8">
        <v-btn color="primary" tile dark @click="openAdd">
          <v-icon>mdi-plus</v-icon>
          {{ $t('addConfig') }}
        </v-btn>
      </v-sheet>
      <v-data-table
          :items-per-page="5"
          :loading="$store.getters.GET_LOADING"
          :headers="headers"
          :items="configs"
          :search="search"
          class="elevation-1 nitg__width-100 rounded-0"
      >
        <template v-slot:item.link="{ item }">
          <span v-html="$options.filters.truncateHtml(item.link, 20)"></span>
        </template>
        <template v-slot:item.title="{ item }">
          <span v-html="$options.filters.truncateHtml(item.title, 20)"></span>
        </template>
        <template v-slot:item.description="{ item }">
          <span v-html="$options.filters.truncateHtml(item.description, 20)"></span>
        </template>
        <template v-slot:item.price="{ item }">
          <span v-html="$options.filters.truncateHtml(item.price, 20)"></span>
        </template>
        <template v-slot:item.url="{ item }">
          <span v-html="$options.filters.truncateHtml(item.url, 20)"></span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              @click="openUpdate(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
              class="ml-2"
              small
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog :width="$vuetify.breakpoint.width / 1.6"
              content-class="rounded-0"
              v-model="show.addConfig">
      <v-card flat tile color="white">
        <v-card-title>
          <span>{{ $t('addConfig') }}</span>
          <v-spacer/>
          <v-btn icon @click="closeAdd">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <validation-observer ref="observer" v-slot="{ passes }">
            <v-form @submit.prevent="passes( submit )">
              <v-checkbox v-model="hasPagination" :label="$t('configForm.pagination.hasPagination')"></v-checkbox>
              <template v-if="hasPagination">
                <v-text-field dense
                              type="text" class="my-8"
                              :label="$t('configForm.pagination.info.quantity.label')"
                              :placeholder="$t('configForm.pagination.info.quantity.placeholder')"
                              v-model="form.page_quantity"></v-text-field>
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.pagination.info.link.label')"
                              :placeholder="$t('configForm.pagination.info.link.placeholder')"
                              v-model="form.pagination_link"></v-text-field>
              </template>
              <validation-provider :name="$t('configForm.url.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="my-8"
                              :label="$t('configForm.url.label')"
                              :placeholder="$t('configForm.url.placeholder')"
                              v-model="form.url"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.link.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.link.label')"
                              :placeholder="$t('configForm.link.placeholder')"
                              v-model="form.link"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.title.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.title.label')"
                              :placeholder="$t('configForm.title.placeholder')"
                              v-model="form.title"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.description.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.description.label')"
                              :placeholder="$t('configForm.description.placeholder')"
                              v-model="form.description"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.price.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.price.label')"
                              :placeholder="$t('configForm.price.placeholder')"
                              v-model="form.price"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <v-card-actions>
                <v-spacer/>
                <v-btn :loading="loadings.submit" type="submit" tile color="primary">
                  <span class="hidden-sm-and-down">{{ $t('configForm.button') }} </span>
                </v-btn>
                <v-btn :loading="loadings.test" type="button" @click="test" tile color="info">
                  <span class="hidden-sm-and-down">{{ $t('configForm.test') }} </span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog :width="$vuetify.breakpoint.width / 1.6"
              content-class="rounded-0"
              v-model="show.updateConfig">
      <v-card flat tile color="white">
        <v-card-title>
          <span>{{ $t('updateConfig') }}</span>
          <v-spacer/>
          <v-btn icon @click="closeUpdate">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <validation-observer ref="update" v-slot="{ passes }">
            <v-form @submit.prevent="passes( update )">
              <validation-provider :name="$t('configForm.url.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="my-8"
                              :label="$t('configForm.url.label')"
                              :placeholder="$t('configForm.url.placeholder')"
                              v-model="form.url"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.link.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.link.label')"
                              :placeholder="$t('configForm.link.placeholder')"
                              v-model="form.link"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.title.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.title.label')"
                              :placeholder="$t('configForm.title.placeholder')"
                              v-model="form.title"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.description.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.description.label')"
                              :placeholder="$t('configForm.description.placeholder')"
                              v-model="form.description"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('configForm.price.label')"
                                   rules="required" v-slot="{ errors }">
                <v-text-field dense
                              type="text" class="mb-8"
                              :label="$t('configForm.price.label')"
                              :placeholder="$t('configForm.price.placeholder')"
                              v-model="form.price"
                              :error-messages="errors"></v-text-field>
              </validation-provider>
              <v-card-actions>
                <v-spacer/>
                <v-btn :loading="loadings.update" type="submit" tile color="primary">
                  <span class="hidden-sm-and-down">{{ $t('configForm.update') }} </span>
                </v-btn>
                <v-btn :loading="loadings.test" type="button" @click="test" tile color="info">
                  <span class="hidden-sm-and-down">{{ $t('configForm.test') }} </span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog :width="$vuetify.breakpoint.width / 1.6"
              content-class="rounded-0"
              v-model="show.testConfig">
      <v-card flat tile color="white">
        <v-card-title>
          <span>{{ $t('testConfig') }}</span>
          <v-spacer/>
          <v-btn icon @click="closeTest">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="tested">
            <v-data-iterator
                :items="tested"
                item-key="id"
                :items-per-page="6"
            >
              <template v-slot:default="{ items }">
                <v-row>
                  <v-col
                      v-for="item in items"
                      :key="item.title"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="4"
                  >
                    <v-card tile :height="$vuetify.breakpoint.height / 2" style="overflow-y: auto">
                      <v-card-title>
                        <h6>{{ item.title }}</h6>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-0">
                        <v-list
                            dense
                        >
                          <v-list-item>
                            <v-list-item-content class="align-end">
                              {{ item.url }}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content class="align-end">
                              <v-btn icon :href="item.link" target="_blank">
                                <v-icon>mdi-open-in-new</v-icon>
                              </v-btn>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content v-html="$options.filters.truncateHtml(item.description, 40)"> </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content v-html="$options.filters.truncateHtml(item.price, 40)">
                              {{ item.price }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar tile
                :width="$vuetify.breakpoint.width / 3"
                color="primary"
                timeout="-1" top multi-line v-model="show.delete">
      <v-card flat tile color="transparent">
        <v-card-text>
          {{ $t('confirmation.message') }}
        </v-card-text>
      </v-card>
      <template v-slot:action>
        <v-spacer></v-spacer>
        <v-btn tile :loading="loadings.deleting"
               class="white--text"
               text
               dark
               @click="confirmDelete">{{ $t('confirmation.yes') }}</v-btn>
        <v-btn tile class="ml-3 white--text"
               text
               dark
               @click="closeConfirmation">{{ $t('confirmation.no') }}</v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
export default {
  name: "Configure",
  data () {
    return {
      hasPagination: false,
      configs: [],
      search: '',
      id: null,
      loadings: {
        submit: false,
        configs: false,
        deleting: false,
        update: false,
        test: false
      },
      show: {
        addConfig: false,
        updateConfig: false,
        testConfig: false,
        delete: false
      },
      form: {
        title: null,
        link: null,
        description: null,
        price: null,
        url: null
      },
      tested: null
    }
  },
  mounted() {
    this.getConfigs()
  },
  methods: {
    openAdd () {
      this.show.addConfig = true
    },
    openTest () {
      this.show.testConfig = true
    },
    openUpdate (item) {
      this.show.updateConfig = true
      this.form = {
        title: item.title,
        link: item.link,
        description: item.description,
        price: item.price,
        url: item.url,
      }
      this.id = item.id
    },
    closeAdd () {
      this.show.addConfig = false
    },
    closeUpdate () {
      this.show.updateConfig = false
    },
    closeTest () {
      this.show.testConfig = false
    },
    submit () {
      this.loadings.submit = true
      this.$http
          .post('api/v2/auth/config', this.form)
          .then(response => {
            this.configs = response.data.configs
            this.form = this.$worker.resetForm(this.form);
            this.$refs.observer.reset()
            this.closeAdd();
          })
          .finally(() => {
            this.loadings.submit = false
          })
    },
    update () {
      this.loadings.update = true
      this.$http.patch(`api/v2/auth/config/${this.id}`, this.form)
          .then(response => {
            this.configs = response.data.configs
            this.form = this.$worker.resetForm(this.form);
            this.$refs.update.reset()
            this.id = null
            this.closeUpdate();
          })
          .finally(() => {
            this.loadings.update = false
          })
    },
    test () {
      if ((this.$refs.update && !this.$refs.update.validate()) || (this.$refs.observer && !this.$refs.observer.validate())) {
        return;
      } else {
        this.loadings.test = true
        this.$http.post(`api/v2/auth/test`, this.form)
            .then(response => {
              this.closeUpdate();
              this.closeAdd();
              this.tested = response.data.tested
              this.openTest()
            })
            .finally(() => {
              this.loadings.test = false
            })
      }
    },
    getConfigs () {
      this.loadings.configs = true
      this.$http.get('api/v2/auth/config')
          .then(response => {
            this.configs = response.data.configs
          })
          .finally(() => {
            this.loadings.configs = false
          })
    },
    confirmDelete () {
      this.loadings.deleting = true
      this.$http.delete(`api/v2/auth/config/${this.id}`,)
          .then((response) => {
            this.configs = response.data.configs
            this.show.delete = false
            this.id = null
          })
          .finally(() => {
            this.loadings.deleting = false
          })
    },
    closeConfirmation () {
      this.show.delete = false
      this.item = {}
    },
    deleteItem (item) {
      this.show.delete = true
      this.id = item.id
    }
  },
  computed: {
    headers () {
      return this.$t('parsersHeaders')
    }
  }
}
</script>

<style scoped>

</style>
